import i18n from '../../i18n.json';

export { i18n };
